import React from "react";
import { Redirect } from "react-router-dom";
import { useJointAccountHolderAccess } from "../../context/JointAccountHolder/JointAccountHolderAccess";
import { pageRoutes } from "../../consts";
import { JointAccountHolderFlow } from "../../screens/JointAccountHolder/Flow";

export const JointAccountHolderRoute = () => {
  const { eligible, hasHardship, accounts } = useJointAccountHolderAccess();
  return eligible ? (
    <JointAccountHolderFlow hasHardship={hasHardship} accounts={accounts} />
  ) : (
    <Redirect to={pageRoutes.base} />
  );
};
